export const navigation = {
  en: {
    inicio: 'Home',
    sobre: 'About',
    habilidades: 'Skills',
    experiencia: 'Experience',
    projetos: 'Projects',
    certificacoes: 'Certifications',
    educacao: 'Education',
    idiomas: 'Languages',
    contato: 'Contact',
    downloadCV: 'Download CV',
    cvLink: '/resume.pdf'
  },
  pt: {
    inicio: 'Início',
    sobre: 'Sobre',
    habilidades: 'Habilidades',
    experiencia: 'Experiência',
    projetos: 'Projetos',
    certificacoes: 'Certificações',
    educacao: 'Educação',
    idiomas: 'Idiomas',
    contato: 'Contato',
    downloadCV: 'Download CV',
    cvLink: '/curriculo.pdf'
  }
};